import React from 'react';

//components
import EditMsg from '../functions/EditMsg';

//blueprint
import { Button, Classes, Dialog, } from "@blueprintjs/core";
// import { Tooltip2 } from "@blueprintjs/popover2";

const DialogFSPBlue = ({openDialog, setOpen, project, profile, setSave}) => {

    const handleClick = (setOpen,openDialog,setSave) => {
        setOpen(!openDialog); 
        setSave(false)
    }

    return (
        <div>
            <Dialog
            icon="edit"
            onClose={()=> handleClick(setOpen,openDialog,setSave)}
            title="Edit message"
            autoFocus= 'true'
            canEscapeKeyClose= 'true'
            canOutsideClickClose= 'true'
            enforceFocus= 'true'
            isOpen= {openDialog}
            usePortal= 'true'
            >
                    <div className={Classes.DIALOG_BODY}>
                        <EditMsg 
                        content={project.ProspectContent} 
                        setOpen={setOpen}
                        profile={profile}
                        id={project.id}
                        setSave={setSave}
                        />
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            {/* <Tooltip2 content="This button is hooked up to close the dialog."> */}
                                <Button onClick={()=> handleClick(setOpen,openDialog,setSave)}>Cancel</Button>
                            {/* </Tooltip2> */}
                        </div>
                    </div>
                </Dialog>
        </div>
    )
}

export default DialogFSPBlue
